(function () {
  function initMarquee(section) {
    var wrap = section.querySelector('[data-marquee-track]');
    var track = wrap;
    var firstGroup = section.querySelector('[data-marquee-group]');
    if (!track || !firstGroup) return;

    var wrapWidth = section.querySelector('.marquee-section__track-wrap').offsetWidth;
    var groupWidth = firstGroup.offsetWidth;

    if (groupWidth === 0) return;

    // Duplicate the group until total width is at least 2x the visible wrap width,
    // guaranteeing a seamless loop with the 50% transform in CSS.
    var totalWidth = groupWidth;
    var safety = 0;
    while (totalWidth < wrapWidth * 2 && safety < 20) {
      var clone = firstGroup.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      totalWidth += groupWidth;
      safety++;
    }

    // Ensure at least one duplicate exists so the 50% keyframe always lines up
    if (track.children.length === 1) {
      var dup = firstGroup.cloneNode(true);
      dup.setAttribute('aria-hidden', 'true');
      track.appendChild(dup);
    }

    var direction = section.getAttribute('data-direction') === 'right' ? 'right' : 'left';
    track.setAttribute('data-animate', direction);
  }

  function initAll() {
    document.querySelectorAll('[data-marquee-section]').forEach(function (section) {
      // Reset in case of theme editor re-render
      var track = section.querySelector('[data-marquee-track]');
      if (track && track.dataset.marqueeInitialized) return;
      initMarquee(section);
      if (track) track.dataset.marqueeInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on theme editor section load/reorder so widths recalculate correctly
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-marquee-section]');
    if (section) initMarquee(section);
  });

  window.addEventListener('resize', function () {
    clearTimeout(window.__marqueeResizeTimer);
    window.__marqueeResizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-marquee-section]').forEach(function (section) {
        var track = section.querySelector('[data-marquee-track]');
        if (track) {
          // remove clones and re-run
          var firstGroup = track.querySelector('[data-marquee-group]');
          Array.from(track.children).forEach(function (child, i) {
            if (i > 0) track.removeChild(child);
          });
          track.removeAttribute('data-animate');
          delete track.dataset.marqueeInitialized;
          initMarquee(section);
        }
      });
    }, 250);
  });
})();
